module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_core-js@2.6.5@core-js/library/modules/_add-to-unscopables.js
// module id = 489
// module chunks = 0